module.exports = __webpack_public_path__ + "static/media/Poppins-Regular.52317b4a.ttf";